import React  from "react";

import { Card, Button, Modal , Col} from "reactstrap";
import YoutubeEmbed from "./YoutubeEmbed";
import PropTypes from "prop-types";


// React Component to display individual item
function AwardS3VideoItem({ companyname, productname, embedId, awardlogo ,category,videoId, videoTemplate}) {
  const [open, setOpen] = React.useState(false);
  const [videoData, setVideoData] = React.useState({});

  const checkplayer= async (id, src, prod, company) => {
   //document.getElementById('EventVideo_'+id).muted = true;
  //  let player = videojs('EventVideo_'+id);
  setOpen(true)
  setVideoData({url:src,productname: prod, companyname: company})
  //  // Setting the volume of video player
  //  player.volume(0);
  console.log('src: ', src)
  }

 
  const closeModalPopup = () => {
    setOpen(false);
    setVideoData({})
  }
  return(
    
  
    <div className="col-lg-4">

        <Modal className="modal-dialog-centered"
             size="lg" isOpen={open}>
                <div className="modal-header">
                {videoData && <h2>{videoData.companyname} - {videoData.productname}</h2> }
                  <button aria-label="Close" className="close" data-dismiss="modal" type="button"  onClick={closeModalPopup}>
                    <span aria-hidden={true}>×</span>
                  </button>
                </div>
                {videoData && <div className="modal-body">
                    <video src={videoData.url} width="100%"  height="60%" controls autoPlay="true"/>
                </div> }
                               
      
                <div className="modal-footer">
                 <Col lg="6" className="text-left">
                
                </Col> 
                <Col lg="6" className="text-right">
             
                <Button color="secondary"  type="button"  isOpen={open}    onClick={closeModalPopup}>Close</Button>
                </Col></div>           
      
      </Modal>
  <Card className="item-container">
  
    <div>
      {/* <div className="col-lg-4" style={{padding:"0"}}>
      <span className="item-label" style={{display:"inline-block", marginBottom:"20px"}}>Product Name:</span>
      </div>
      <div className="col-lg-5" style={{padding:"0"}}>
      <p>{productname}</p>
      </div> */}
      {(awardlogo == null) ?
      <><div title={companyname} style={{ textOverflow:"ellipsis", overflow:"hidden", width:"350px", whiteSpace:"nowrap" , padding:'3px 0  0 10px'}}>
      <strong>Company Name:</strong> {companyname}
      </div>

      {/* <div title={productname} style={{ textOverflow:"ellipsis", overflow:"hidden", width:"350px", whiteSpace:"nowrap"}}>
      <strong>Product Name:</strong> {productname}
      </div> */}
      </>
       :
       <>
      <div title={companyname} style={{ textOverflow:"ellipsis", overflow:"hidden", width:"310px", whiteSpace:"nowrap", padding:'3px 0  0 10px'}}>
      <strong>Company Name:</strong> {companyname}
     
      </div>

      {/* <div title={productname} style={{ textOverflow:"ellipsis", overflow:"hidden", width:"310px", whiteSpace:"nowrap"}}>
      <strong>Product Name:</strong> {productname}
      </div>  */}
      </> }
    </div>
    <div className="award-logo">
      <img  src={awardlogo} />
    </div>
    <div style={{display: 'flex', justifyContent: 'center',alignItems: 'center'}}>
      <div className="video-responsive" style={{padding:'20px'}}>  

        <img src={videoTemplate?videoTemplate:process.env.REACT_APP_DEFALTIMAGE+"document/company/logo/videoTemp.jpg"} style={{ borderRadius: '20px', cursor:"pointer", width: "-webkit-fill-available", height: "-webkit-fill-available" }} onClick={() => checkplayer(videoId, process.env.REACT_APP_CDN_URL+embedId, productname, companyname)}></img>

        {/* <span>
          <img src="/images/playImage.png" style={{height:"48px", cursor:"pointer" , position:"absolute",top: "119px",left: "230px"}} onClick={() => checkplayer(videoId, process.env.REACT_APP_CDN_URL+embedId, productname, companyname)}/>
        </span> */}

      </div>
    </div>
  </Card>
  </div>
)};
// YoutubeEmbed.propTypes = {
//   embedId: PropTypes.string.isRequired
// };

export default AwardS3VideoItem;